module.exports = __webpack_public_path__ + "img/img21.44923568.png";